import React, { useEffect, useState } from "react";
import Layout from "../../Components/Layout";
import Sidebar from "../../Components/Sidebar";
import {
  Box,
  Button,
  Step,
  StepContent,
  StepLabel,
  Stepper,
  Typography,
} from "@mui/material";
import Banner from "../../Assets/funeral.webp";
import Logo from "../../Assets/Logo.svg";
import axios from "axios";
import { useGlobal } from "../../Helper/Context/GlobalContext";
import ErrorBox from "../../Components/ErrorBox";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import Whatsapp from "../../Components/Whatsapp";

const steps = [
  {
    label: "Masuk atau buat akun baru",
    description: `Masuk atau Daftarkan email anda`,
    image: "../../Assets/Steps/step1.jpg",
  },
  {
    label: "Temukan mendiang",
    description:
      "Pilih mendiang untuk mengirimkan pesan duka, anda dapat mencarinya berdasarkan nama atau rumah duka",
    image: "../../Assets/Steps/step2.jpg",
  },
  {
    label: "Pilih pesan",
    description: `Anda dapat mengirimkan pesan digital sesuai kreasi anda atau dapat memilih template kami yang beragam`,
    image: "../../Assets/Steps/step3.jpg",
  },
  {
    label: "Pilih template design",
    description: `Jika anda belum memiliki design karangan bunga, kami memiliki template beragam yang dapat anda gunakan`,
    image: "../../Assets/Steps/step4.jpg",
  },
  {
    label: "Sesuaikan isi pesan",
    description: `Isi form untuk mengubah menyesuaikan isi pesan, anda dapat mengunggah logo perusahaan dan menyampaikan pesan untuk yang sedang berduka`,
    image: "../../Assets/Steps/step5.jpg",
  },
  {
    label: "Pembayaran",
    description: `Pilih salah satu dari beberapa metode pembayaran untuk menyelesaikan transaksi online anda`,
    image: "../../Assets/Steps/step6.jpg",
  },
  {
    label: "Pesan InMemoriam anda langsung tayang!",
    description: `Selamat, pesan InMemoriam anda sudah tayang di ruang duka, semoga keluarga yang ditinggalkan dapat merasa lebih baik karna pesan dukungan anda`,
    image: "../../Assets/Steps/step7.jpg",
  },
];

const benefits = [
  {
    label: "Peduli Lingkungan, Kurangi Limbah",
    description: `Papan bunga konvensional mengandung banyak bahan yang sulit terurai seperti styrofoam dan plastik. In Memoriam menawarkan alternatif digital yang sepenuhnya bebas limbah dan lebih ramah lingkungan.`,
    image: "../../Assets/Benefit/green.svg",
  },
  {
    label: "Minim Polusi, Tanpa Ribet",
    description: `Pengiriman papan bunga membutuhkan banyak perjalanan yang berkontribusi pada polusi udara. Dengan In Memoriam, ucapan Anda langsung ditampilkan di lokasi tanpa perlu transportasi tambahan.`,
    image: "../../Assets/Benefit/nopolution.svg",
  },
  {
    label: "Tertata Rapi, Tampilan Elegan",
    description: `Tanpa papan bunga yang menumpuk dan sulit diatur, In Memoriam menghadirkan tampilan modern yang terintegrasi dengan lokasi acara, menjaga kebersihan dan estetika.`,
    image: "../../Assets/Benefit/trash.svg",
  },
  {
    label: "Cepat, Praktis, dan Instan",
    description: `Pesan ucapan kapan saja melalui aplikasi web kami, bahkan saat acara berlangsung, dan lihat pesan Anda langsung ditampilkan di layar In Memoriam.`,
    image: "../../Assets/Benefit/quick.svg",
  },
  {
    label: "Pesan Akurat, Bebas Typo",
    description: `Kesalahan ejaan bisa merusak kesan. In Memoriam menyediakan pratinjau sebelum pemesanan dikonfirmasi, memastikan setiap kata tersampaikan dengan benar.`,
    image: "../../Assets/Benefit/preview.svg",
  },
  {
    label: "Desain Modern & Menarik",
    description: `Pilih dari berbagai template eksklusif. Dengan tampilan yang bersih dan mudah dibaca dari jauh, ucapan Anda akan tampil lebih berkesan.`,
    image: "../../Assets/Benefit/design.svg",
  },
];

export default function About() {
  //==================================================Context
  const masukContext = useGlobal();
  const { openErrorBox, setErrorServer, setToOpenRegister } = masukContext;

  const history = useHistory();

  const [activeStep, setActiveStep] = useState(0);
  const handleChangeStep = (indexStep) => {
    setActiveStep(indexStep);
  };

  const [showTemplate, setShowTemplate] = useState([]);

  const getDaftarTemplate = async () => {
    const url = process.env.REACT_APP_BASE_URL + "api/template/template";
    try {
      const response = await axios.get(url);
      console.log(response);
      const getItemsByCategory = (religi, limit) =>
        response.data.filter((item) => item.religi === religi).slice(0, limit);

      const result = [
        ...getItemsByCategory("General", 6),
        ...getItemsByCategory("Kristen", 3),
        ...getItemsByCategory("Budha", 3),
        ...getItemsByCategory("Hindu", 3),
        ...getItemsByCategory("Islam", 3),
      ];

      setShowTemplate(result);
    } catch (error) {
      if (!!error.response.data) {
        setErrorServer(error.response.data);
      } else {
        setErrorServer(
          "Terjadi error saat mengambil data template, Mohon coba lagi"
        );
      }
      openErrorBox();
    }
  };

  const [daftarRD, setDaftarRD] = useState([]);

  const getDaftarRD = async () => {
    const url = process.env.REACT_APP_BASE_URL + "api/RumahDuka/RumahDuka";
    try {
      const response = await axios.get(url);
      setDaftarRD(
        response.data.map((e) => {
          return {
            pk_id_rd: e.pk_id_rd,
            guid_rd: e.guid_rd,
            nama_rd: e.nama_rd,
            alamat: e.alamat,
            tlp: e.tlp,
            nama_kota: e.nama_kota,
            nama_prov: e.nama_prov,
            fk_id_avatar: e.fk_id_avatar,
            path_image: e.path_image,
          };
        })
      );
    } catch (error) {
      if (error.response.data.length < 100) {
        setErrorServer(error.response.data);
      } else {
        setErrorServer(
          "Terjadi error saat mengambil data rumah duka, Mohon coba lagi"
        );
      }
      openErrorBox();
    }
  };
  useEffect(() => {
    getDaftarTemplate();
    getDaftarRD();
  }, []);

  return (
    <Layout>
      <ErrorBox />
      <Whatsapp />
      <Box
        sx={{
          backgroundImage: `url(${Banner})`,
          width: "100%",
          height: "100vh",
          objectFit: "cover",
          backgroundRepeat: "no-repeat",
          backgroundSize: "cover",
          display: "flex",
          alignItems: "center",
          flexDirection: "column",
          position: "relative",
          justifyItems: "center",
        }}
      >
        <Box
          sx={{
            width: "100%",
            height: "100%",
            backgroundImage:
              "linear-gradient(to bottom, #BC8EEE, rgba(255, 126, 95, 0))",
            position: "absolute",
            display: "flex",
            alignItems: "center",
            flexDirection: "column",
          }}
        >
          <Box
            sx={{
              width: "80%",
              display: "flex",
              alignItems: "center",
              flexDirection: "column",
            }}
          >
            <Typography
              variant="h3"
              mt={10}
              sx={{
                textShadowColor: "white",
                textShadowOffset: { width: -1, height: 0 },
                textShadowRadius: 10,
                textAlign: "center",
                color: "white",
                fontWeight: "bold",
              }}
            >
              Kirim Ucapan Belasungkawamu
              <br />
              Dengan InMemoriam
            </Typography>
            <Typography textAlign={"center"} color={"white"} mt={2}>
              Situasi duka, tentu saja pernah dialami oleh setiap manusia. Oleh
              sebab itu, orang-orang sekitar perlu berusaha menguatkan dan
              mendukung mereka dengan baik.
            </Typography>
          </Box>
        </Box>
      </Box>
      <Box
        id="cara-memesan"
        sx={{
          width: "100%",
          display: "flex",
          alignItems: "center",
          flexDirection: "column",
          p: { xs: 3, md: 10 },
          boxSizing: "border-box",
        }}
      >
        <img src={Logo} alt="logo Inmemoriam" width={60} />
        <Typography
          variant="h2"
          mt={10}
          sx={{
            textShadowColor: "white",
            textShadowOffset: { width: -1, height: 0 },
            textShadowRadius: 10,
            textAlign: "center",
          }}
        >
          Bagaimana cara mengirim ucapan InMemoriam?
        </Typography>
        <Typography mt={2}>
          Berikut langkah - langkah mengirim ucapan InMemoriam
        </Typography>
        <Box
          sx={{
            display: "flex",
            width: "100%",
            flexWrap: "wrap",
            mt: 3,
          }}
        >
          <Box
            sx={{
              flexGrow: 1,
              width: "30%",
            }}
          >
            <Stepper activeStep={activeStep} orientation="vertical">
              {steps.map((step, index) => (
                <Step
                  key={step.label}
                  onClick={() => {
                    handleChangeStep(index);
                  }}
                >
                  <StepLabel>
                    <Typography variant="h5">{step.label}</Typography>
                  </StepLabel>
                  <StepContent>
                    <Typography>{step.description}</Typography>
                  </StepContent>
                </Step>
              ))}
            </Stepper>
          </Box>
          <Box
            sx={{
              flexGrow: 2,
              width: "400px",
            }}
          >
            <Box
              sx={{
                width: "100%",
                borderRadius: "10px",
                overflow: "hidden",
              }}
            >
              <img
                src={steps[activeStep].image}
                width="100%"
                style={{ objectFit: "cover" }}
                alt={`Step ${activeStep}`}
              />
            </Box>
          </Box>
        </Box>
      </Box>
      <Box
        id="mengapa-inmemoriam"
        sx={{
          width: "100%",
          display: "flex",
          alignItems: "center",
          flexDirection: "column",
          p: { xs: 3, md: 10 },
          boxSizing: "border-box",
          backgroundColor: "rgb(239, 239, 239)",
        }}
      >
        <img src={Logo} alt="logo Inmemoriam" width={60} />
        <Typography
          variant="h2"
          mt={10}
          sx={{
            textShadowColor: "white",
            textShadowOffset: { width: -3, height: 1 },
            textShadowRadius: 10,
            textAlign: "center",
          }}
        >
          Mengapa Menggunakan InMemoriam?
        </Typography>

        <Box
          sx={{
            display: "flex",
            width: "100%",
            gap: 2,
            flexWrap: "wrap",
            mt: 3,
          }}
        >
          {benefits?.map((benefit, index) => (
            <Box
              key={index}
              sx={{
                flexGrow: 1,
                width: "300px",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              <img src={benefit.image} alt={benefit.label} width={80} />
              <Typography sx={{ textAlign: "center", fontWeight: "bold" }}>
                {benefit.label}
              </Typography>
              <Typography variant="caption" sx={{ textAlign: "center" }}>
                {benefit.description}
              </Typography>
            </Box>
          ))}
        </Box>
        <Button
          onClick={() => {
            history.push("/daftar-mendiang");
          }}
          variant="contained"
          size="small"
          sx={{
            borderRadius: "999px",
            textTransform: "none",
            fontWeight: "400",
            marginRight: "20px",
            mt: 5,
          }}
        >
          Kirim pesan InMemoriam
        </Button>
      </Box>
      <Box
        id="lokasi"
        sx={{
          width: "100%",
          display: "flex",
          alignItems: "center",
          flexDirection: "column",
          p: { xs: 3, md: 10 },
          boxSizing: "border-box",
        }}
      >
        <img src={Logo} alt="logo Inmemoriam" width={60} />
        <Typography
          variant="h2"
          mt={7}
          sx={{
            textShadowColor: "white",
            textShadowOffset: { width: -1, height: 0 },
            textShadowRadius: 10,
            textAlign: "center",
          }}
        >
          Beberapa mitra tempat kami
        </Typography>
        <Typography textAlign="center" mt={2}>
          Anda akan dapat mengirim pesan InMemoriam jika acara diadakan di salah
          satu lokasi ini. Kami terus bekerja untuk bermitra dengan lebih banyak
          tempat di seluruh Indonesia.
        </Typography>
        <Box
          sx={{
            display: "flex",
            width: "100%",
            gap: 2,
            flexWrap: "wrap",
            mt: 3,
          }}
        >
          {daftarRD?.map((rumahDuka, index) => (
            <Box
              key={index}
              sx={{
                flexGrow: 1,
                width: "300px",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              <img
                src={process.env.REACT_APP_BASE_URL + rumahDuka.path_image}
                alt={rumahDuka.nama_rd}
                width={120}
              />
              <Typography sx={{ textAlign: "center", fontWeight: "bold" }}>
                {rumahDuka.nama_rd}
              </Typography>
              <Typography sx={{ textAlign: "center" }}>
                {`${rumahDuka.alamat}, ${rumahDuka.nama_kota}, ${rumahDuka.nama_prov}`}
              </Typography>
            </Box>
          ))}
        </Box>
      </Box>
      <Box
        id="template"
        sx={{
          width: "100%",
          display: "flex",
          alignItems: "center",
          flexDirection: "column",
          p: { xs: 3, md: 10 },
          boxSizing: "border-box",
          backgroundColor: "rgb(239, 239, 239)",
        }}
      >
        <img src={Logo} alt="logo Inmemoriam" width={60} />
        <Typography
          variant="h2"
          mt={10}
          sx={{
            textShadowColor: "white",
            textShadowOffset: { width: -1, height: 0 },
            textShadowRadius: 10,
            textAlign: "center",
          }}
        >
          Preview beberapa template InMemoriam
        </Typography>

        <Box
          sx={{
            flexWrap: "wrap",
            display: "flex",
            width: "100%",
            gap: 2,
            mt: 3,
          }}
        >
          {showTemplate.map((template, index) => (
            <Box
              key={index}
              sx={{
                flexGrow: 1,
                flexShrink: 1,
                width: "300px",
              }}
            >
              <img
                width="100%"
                style={{ objectFit: "cover" }}
                src={
                  process.env.REACT_APP_BASE_URL + template?.path_thumb_template
                }
                alt={template?.nama_template}
              />
            </Box>
          ))}
        </Box>
      </Box>
      <Box
        sx={{
          width: "100%",
          display: "flex",
          alignItems: "center",
          flexDirection: "column",
          p: { xs: 3, md: 10 },
          boxSizing: "border-box",
        }}
      >
        <img src={Logo} alt="logo Inmemoriam" width={60} />
        <Typography
          variant="h2"
          mt={10}
          sx={{
            textShadowColor: "white",
            textShadowOffset: { width: -1, height: 0 },
            textShadowRadius: 10,
            textAlign: "center",
          }}
        >
          Ayo Kita Mulai!
        </Typography>

        <Box
          sx={{
            flexWrap: "wrap",
            display: "flex",
            width: "100%",
            gap: 2,
            mt: 3,
          }}
        >
          <Box
            sx={{
              flexGrow: 1,
              flexShrink: 1,
              width: "300px",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <img
              width="50%"
              style={{ objectFit: "cover" }}
              src="../../Assets/order.jpg"
              alt="oerder"
            />
            <Typography sx={{ textAlign: "center", fontWeight: "bold", mt: 3 }}>
              Kirim Ucapan Belasungkawa mu
            </Typography>
            <Typography sx={{ textAlign: "center" }}>
              Siap mengirim ucapan Inmemoriam? Buat akun dan pesanan dalam
              hitungan menit!
            </Typography>
            <Button
              onClick={() => {
                history.push("/");
                setToOpenRegister();
              }}
              variant="contained"
              size="small"
              sx={{
                borderRadius: "999px",
                textTransform: "none",
                fontWeight: "400",
                marginRight: "20px",
                mt: 5,
              }}
            >
              Daftar Sekarang
            </Button>
          </Box>
          <Box
            sx={{
              flexGrow: 1,
              flexShrink: 1,
              width: "300px",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <img
              width="50%"
              style={{ objectFit: "cover" }}
              src="../../Assets/join-partner.jpg"
              alt="oerder"
            />
            <Typography sx={{ textAlign: "center", fontWeight: "bold", mt: 3 }}>
              Bergabung bersama kami
            </Typography>
            <Typography sx={{ textAlign: "center" }}>
              Siap menghadirkan layanan terbaik di rumah duka Anda? Hubungi kami
              sekarang dan berikan pengalaman yang lebih bermakna bagi klien
              dengan layar In Memoriam yang ramah lingkungan
            </Typography>
            <Button
              onClick={() => {
                history.push("/gabung-mitra");
              }}
              variant="contained"
              size="small"
              sx={{
                borderRadius: "999px",
                textTransform: "none",
                fontWeight: "400",
                marginRight: "20px",
                mt: 5,
              }}
            >
              Gabung Mitra
            </Button>
          </Box>
        </Box>
      </Box>
      <Box
        sx={{
          bgcolor: "primary.main",
          justifyContent: "space-between",
          display: "flex",
          p: { xs: 3, md: 10 },
          boxSizing: "border-box",
          flexWrap: "wrap",
          gap: 3,
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexGrow: 1,
            flexWrap: "warp",
            gap: 2,
            flexDirection: "column",
          }}
        >
          <Box
            sx={{
              display: "flex",
              flexGrow: 1,
              flexWrap: "warp",
              alignItems: "center",
              gap: 2,
            }}
          >
            <img src={Logo} alt="logo Inmemoriam" width={50} />
            <Typography
              sx={{
                textShadowColor: "white",
                textShadowOffset: { width: -1, height: 0 },
                textShadowRadius: 10,
                textAlign: "center",
                fontFamily: "Affinity Future",
                color: "white",
                fontSize: 30,
              }}
            >
              InMemoriam
            </Typography>
          </Box>
          <Typography sx={{ color: "white" }}>
            Ucapan spesial dengan sentuhan modern – kirim papan bunga digital{" "}
            <br />
            yang lebih ramah lingkungan dan praktis!
          </Typography>
        </Box>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "end",
            flexGrow: 1,
          }}
        >
          <Typography
            sx={{ color: "white", fontWeight: "bold", textAlign: "end" }}
          >
            Email
          </Typography>
          <Typography sx={{ color: "white", textAlign: "end" }}>
            admin@inmemoriam.id
          </Typography>
          <Typography
            sx={{ color: "white", fontWeight: "bold", textAlign: "end" }}
          >
            Whatsapp
          </Typography>
          <Typography sx={{ color: "white", textAlign: "end" }}>
            0878 2828 8989
          </Typography>
        </Box>
      </Box>
    </Layout>
  );
}
